/**
 * @author gll
 * 功能：打标签模块
 */
import { Service } from '@/tools'
export class TagService<T extends TUser.Tag> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.Tag}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  //标签列表查询
  listTags = <K extends T['ApiListTags']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiListTags', data)

  //标签列表查询
  // /api/user/tag/v1/pageTags
  pageTags = <K extends T['ApiPageTags']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageTags', data)

  //新增标签
  // /api/user/tag/v1/addTag
  addTag = <K extends T['ApiAddTag']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddTag', data, '添加成功')

  //标签详情
  // /api/user/tag/v1/queryByTagId
  queryByTagId = <K extends T['ApiQueryByTagId']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryByTagId', data)

  //标签状态修改
  // /api/user/tag/v1/setState
  setState = <K extends T['ApiSetState']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSetState', data, '操作成功')

  //修改标签
  // /api/user/tag/v1/updateTag
  updateTag = <K extends T['ApiUpdateTag']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateTag', data, '修改成功')

  //删除标签
  // /api/user/tag/v1/deleteTag
  deleteTag = <K extends T['ApiDeleteTag']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteTag', data, '操作成功')
}
